import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ModuleHeader from "../components/ModuleHeader";
import Freight from "@/assets/img/mms/freight.webp";
import Inbound from "@/assets/img/mms/inbound.webp";
import Outbound from "@/assets/img/mms/outbound.webp";
import Inventory from "@/assets/img/mms/inventory.webp";
import moment from "moment";
import { mmsApi } from "@/api/mmsApi";
const InboundOutboundStatus = ({ className = "", }) => {
    // 1. 用 React 状态存储数据
    const [stats, setStats] = useState([]);
    // 加载状态
    const [loading, setLoading] = useState(true);
    // 2. useEffect 调用接口（组件挂载时执行）
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                // 调用接口
                const res = await mmsApi.getInventoryStatistics();
                // 3. 处理接口数据（和你本地写死的结构保持一致）
                let apiData = res.data;
                // 4. 把接口数据映射成页面需要的格式
                const result = [
                    {
                        icon: Inbound,
                        title: "期初库存",
                        value: apiData.startStockAmount || 0, // 接口第一个数据
                    },
                    {
                        icon: Inventory,
                        title: "期末库存",
                        value: apiData.endStockAmount || 0, // 接口第二个数据
                    },
                    {
                        icon: Outbound,
                        title: "本期入库",
                        value: apiData.inAmount || 0, // 接口第三个数据
                    },
                    {
                        icon: Freight,
                        title: "本期出库",
                        value: apiData.outAmount || 0, // 接口第四个数据
                    },
                ];
                // 5. 更新到状态，页面自动刷新
                setStats(result);
            }
            catch (err) {
                console.error("获取库存统计失败：", err);
            }
            finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    return (_jsxs("div", { className: `
        relative bg-gradient-to-tr from-[#071F4A] to-[#0f295300]
        flex flex-col ${className} min-h-0
      `, children: [_jsx(ModuleHeader, { title: "\u51FA\u5165\u5E93\u7EDF\u8BA1", children: _jsx("div", { children: moment().format("YYYY-MM-DD") }) }), _jsx("div", { className: "flex-1 min-h-0 px-[0.1rem] py-[0.1rem]", children: _jsx("div", { className: "h-full grid grid-cols-2 gap-[0.1rem]", children: loading ? (_jsx("div", { className: "text-white text-center", children: "\u52A0\u8F7D\u4E2D..." })) : (stats.map((item, idx) => (_jsxs("div", { className: " flex items-center p-[0.1rem]", children: [_jsx("div", { className: "mr-[0.1rem]", children: _jsx("img", { src: item.icon, alt: item.title, style: { width: "0.77rem", height: "0.65rem" }, className: " object-contain" }) }), _jsxs("div", { className: "flex flex-col", children: [_jsx("div", { className: "text-white text-[0.16rem]", children: item.title }), _jsxs("div", { className: "text-[#57F2FF] text-[0.14rem] font-bold", children: [item.value.toLocaleString(), " \u4E07\u5143"] })] })] }, idx)))) }) })] }));
};
export default InboundOutboundStatus;
